import { Ref, ref } from "vue";
import { defineStore } from "pinia";
import { Account, AccountArray } from "@/services/account/types";
import { AccountService } from "@/services/account/AccountService";

import Swal from "sweetalert2";

export const accountStore = defineStore("account", () => {
  const account: Ref<AccountArray> = ref(new AccountArray());
  const activeAccount: Ref<number> = ref(
    +(localStorage.getItem("activeAccount") ?? 0)
  );

  const accountService = new AccountService();
  const promise: Promise<Response> = new Promise((res) => res);

  const accountSelected = ref<Account>();
  
  const updateAccountErrors = ref<any>({});
  const updateAccountIsPending: boolean | undefined = undefined;

  const query = async (id: number) => {
    const { data } = await accountService.getAccountServices(id);

    if (data?.data) {
      account.value.data = data.data;

      const selected = localStorage.getItem("activeAccount");
      
      accountSelected.value = account.value.data?.find(
        (a) => a.id == activeAccount.value
      );

      if (!selected) {
        setActiveAccount(account.value.data[0]?.id);
      }
    }
  };

  const setActiveAccount = (id: number) => {
    localStorage.setItem("activeAccount", `${id}`);
    activeAccount.value = id;
  };

  const getData = (state: any) => {
    return state.account;
  };

  // Had to pass the selectedAccount because for some reason the reference passed to the view is lost.
  const updateAccount = async (account: any) => { 

    if (account) {
      try { 
        await accountService.changeInfo(account);
  
        return true;
      } catch (error : any) { 
        console.error(error);

        if(error?.response?.data?.errors){
          updateAccountErrors.value = { ... error.response.data.errors };
          
          console.log(updateAccountErrors.value);

          Swal.fire(
            "Error!",
            "Los datos del usuario no han sido modificados. Inténtelo nuevamente.",
            "error"
          ); 
        }   
      }
      return false;
    }

  };
 
  return {
    account,
    activeAccount,

    accountService,
    accountSelected,
    promise,

    query,
    setActiveAccount,

    updateAccount,
    updateAccountErrors,
    updateAccountIsPending,

    getData,
  };
});

export type AccountStore = ReturnType<typeof accountStore>;
